import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { getCategoryById } from 'js/src/data/templates';
import type { TemplateCategoryId } from 'js/src/libs/consts';
import type { RootState } from 'js/src/libs/RootState';

type TemplateCategoryProps = {
    categoryId: TemplateCategoryId;
    activeTemplateCategoryId: TemplateCategoryId | null;
    onClick: (evt: React.MouseEvent, categoryId: TemplateCategoryId) => void;
};

const TemplateCategory = React.memo(function TemplateCategory({
    categoryId,
    onClick,
    activeTemplateCategoryId,
}: TemplateCategoryProps) {
    const category = useSelector((state: RootState) => getCategoryById(state, categoryId));
    const name = category.get('display_name');
    const templateIds = category.get('templates');

    const handleOnTemplateCategoryClick = React.useCallback(
        (evt: React.MouseEvent) => {
            onClick(evt, categoryId);
        },
        [onClick, categoryId],
    );

    if (templateIds.size === 0) {
        return null;
    }

    const isActive = activeTemplateCategoryId === categoryId;

    return (
        <button
            className={classNames('template-category-nav-button py-l5-8 px-l5-12', {
                active: isActive,
            })}
            key="saved-templates"
            onClick={handleOnTemplateCategoryClick}
        >
            {name}
        </button>
    );
});

export default TemplateCategory;
